import Flag from '../../ui-components/Flag';
import SelectItem from '../../general-components/SelectItem';
import styles from './Region.module.css';

const Region = ({
    availableRegions,
    selectedRegions,
    onRegionChange,
}: {
    availableRegions: string[];
    selectedRegions: string[];
    onRegionChange: Function;
}) => {
    let avRegions = availableRegions;
    // Add any value that exists in selectedRegions but not in availableRegions
    if (selectedRegions && Array.isArray(selectedRegions)) {
        const missingRegions = selectedRegions.filter(
            (region) => !avRegions.includes(region)
        );
        if (missingRegions.length > 0) {
            avRegions = [...avRegions, ...missingRegions];
        }
    }
    return (
        <>
            <label className={`${styles.infoLabel} ${styles.required}`}>
                Regions
            </label>
            <div className={styles.inputWrapper}>
                {avRegions.map((region) => (
                    <SelectItem
                        key={region}
                        checked={
                            selectedRegions && selectedRegions.includes(region)
                        }
                        type="checkbox"
                        value={region}
                        label={
                            <>
                                <Flag flag={region} /> {region}
                            </>
                        }
                        onChange={() => onRegionChange(region)}
                    />
                ))}
            </div>
        </>
    );
};

export default Region;
